import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsvExportService {
  /**
   * Generates a CSV string with BOM from header and rows.
   */
  generateCsv(headers: string[], rows: string[][]): string {
    const BOM = '\uFEFF';
    
    const escapeCsv = (val: unknown): string => {
      if (val === null || val === undefined) return '';
      let str = String(val);

      // サニタイズ（CSVインジェクション対策）
      if (/^[=+\-@]/.test(str)) {
        str = "'" + str;
      }

      if (str.includes(',') || str.includes('\n') || str.includes('\r') || str.includes('"')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const headerLine = headers.map(escapeCsv).join(',');
    const rowLines = rows.map(row => row.map(escapeCsv).join(','));

    return BOM + [headerLine, ...rowLines].join('\n');
  }

  /**
   * Triggers a browser download for the generated CSV string.
   */
  downloadCsv(csvContent: string, filename: string): void {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(url);
  }
}
